"use client";

import type { ComponentProps, ReactNode } from "react";

import {
  PluginIcon,
  type PluginIconPlugin,
} from "@/components/content/plugin-icon";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

export type PluginBadgeKind = "plugin" | "skill" | "tool";

/**
 * A plugin, skill or tool as a badge: its icon when the plugin has one, then
 * the label. PluginBadge resolves the plugin from the runtime catalogue; this
 * renders whichever plugin it is given.
 */
export function PluginBadgeView(props: {
  plugin?: PluginIconPlugin | null;
  label: ReactNode;
  kind?: PluginBadgeKind;
  variant?: BadgeVariant;
  className?: string;
}) {
  return (
    <Badge
      variant={props.kind ?? props.variant ?? "outline"}
      className={cn("normal-case", props.className)}
    >
      {props.plugin?.branding?.iconUrl ? (
        <PluginIcon plugin={props.plugin} className="size-3" />
      ) : null}
      {props.label}
    </Badge>
  );
}
